<div class="switcher">
  <a (click)="selectLeft()" [class.switcher--active]="selected === 'left'">
    <span>{{ labelLeft }}</span>
  </a>
  <a (click)="onSelect()">
    <div class="switch-wrapper" data-test="switcher">
      <div
        class="switch"
        [class.switch--left-position]="selected === 'left'"
        [class.switch--right-position]="selected === 'right'"
      ></div>
    </div>
  </a>
  <a (click)="selectRight()" [class.switcher--active]="selected === 'right'">
    <span>{{ labelRight }}</span>
  </a>
</div>
